/**
 * Registers Chart.js scale/element/plugin modules and applies global
 * defaults that mirror the legacy `static/analysis.js` setup: muted
 * gridlines, system sans-serif (matches the body font), bottom legend,
 * and `maintainAspectRatio: false` so canvases fill the chart-card grid
 * cells responsively.
 */

import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Filler,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Tooltip,
} from "chart.js";

let registered = false;

export function ensureChartDefaults(palette: {
  muted: string;
  border: string;
}): void {
  if (registered) {
    // Defaults still need refresh if the palette changes (theme toggle).
    applyPalette(palette);
    return;
  }
  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    PointElement,
    ArcElement,
    Tooltip,
    Legend,
    Filler,
  );
  applyPalette(palette);
  registered = true;
}

function applyPalette(palette: { muted: string; border: string }): void {
  ChartJS.defaults.color = palette.muted;
  ChartJS.defaults.borderColor = palette.border;
  if (typeof document !== "undefined") {
    ChartJS.defaults.font.family = getComputedStyle(document.body).fontFamily;
  }
  ChartJS.defaults.font.size = 11;
  ChartJS.defaults.maintainAspectRatio = false;
  ChartJS.defaults.plugins.legend.labels.boxWidth = 10;
  ChartJS.defaults.plugins.legend.labels.boxHeight = 10;
  ChartJS.defaults.plugins.legend.position = "bottom";
}
